<template>
    <div class="index" id="wrapper" style="margin-top:0;">
    <app-header />
    <!-- <section class="section-1" id="huan10_22" style="overflow: hidden;">
      <div class="Fpictxt">
      </div>
       <div id="canvas"></div> 
    </section>-->
    <div style="width: 100%;height: 100vh;">
      <div class="slideshow">
        <div class="slideshow-image"></div>
        <div class="slideshow-image"></div>
        <div class="slideshow-image"></div>
      </div>
      <div class="cont" style="top:8%;width: 1054px;left: 22%;margin-left: 0;">
        <!-- <div class="cont-txt">
        <h2>AI健康认知大脑</h2>
        <h2>让机器变得更智能</h2>
        <p>用AI认知计算技术、配合人类进行健康和医疗诊断、分析工作<br />解决人脑不擅长解决的一些问题</p>
      </div> -->
        <div class="Fpictxt">
        </div>
        <div class="cont-but">
          <!-- <a href="../aiimp/index.html">产品列表</a> -->
          <!--  <router-link to="/ica" class="buton">智能认知分析</router-link> -->
          <!-- <a href="symp-opt.html" class="buton">智能认知分析</a> -->
        </div>
      </div>
    </div>
    <div class="zhongjiantu11_24">
      <div class="continto">
        <div class="leftcont">
          <div class="title" style="padding-bottom: 30px;padding-top: 80px;">AI健康认知大脑让机器变得更智能</div>
          <div class="title" style="padding-top: 0;font-size: 16px;    padding-bottom: 50px; line-height: 30px;">用AI认知计算技术、配合人类进行健康和医疗诊断、<br>分析工作解决人脑不擅长解决的一些问题</div>
          <router-link to="/ica" class="btntitle11_24">智能认知分析</router-link>
        </div>
        <img src="../assets/images/imgin.png" alt="" class="imgin">
      </div>
    </div>
<!--     <div class="zhongjiantu3_25">
      <div class="continto">
        <div class="titlein">慢性病风险评估与筛查</div>
        <div class="titleinps">慢性病风险筛查与评估，就是针对生活习惯、环境因素、智能设备、家庭遗传、体检结果指标等进行科学的分析，在未出现临床表现的人群中分析评估其健康危险因素，建立生活方式、环境、遗传等危险因素与健康状态之间的量化关系，预测个人在未来5~10年内多种慢性疾病的患病风险和概率，从而实现早预防，早干预的目标。</div>
        <div class="weiqunabox3_25">
          <div class="weiquna3_25" v-for="val in msg">
            <img :src="val.img" alt="" class="img">
            <div class="titlewei">{{val.name}}</div>
            <div class="titleweips">{{val.title}}</div>
            <div class="btnuni" @click="tiao(val.type,val.name)">体验评估</div>
          </div>
          <div class="weiquna3_25">
            <div class="img"></div>
            <div class="titlewei"></div>
            <div class="titleweips">更多风险评估系统即将上线</br>敬请期待</div>
           
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div> -->
    <div id="main">
      <div class="introduce-body">
        <div class="box-1">
          <div class="title">人体医学生物特征认知诊断技术业务专家<br />在线提供免费 一对一需求评估服务</div>
          <div class="info-cont">
            <div class="carousel pic-box">
              <div class="ant-carousel">
                <div class="slick-initialized slick-slider">
                  <div class="slick-list">
                    <div class="slick-track" style="opacity: 1; width: 2360px;">
                      <div data-index="0" class="slick-slide slick-active" tabindex="-1" style="outline: none; width: 590px;"><img src="../assets/images/article/news-21.jpg" width="590px"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <dl class="info-box">
              <dt>一对一在线需求评估</dt>
              <dd>从您提交需求的一刻起，将会有资深需求分析师通过在线需求评估系统为您提供一对一诊断，让您了解自己的想法转变成系统和平台会有哪些工作。</dd>
              <dt>项目过程视频电话沟通</dt>
              <dd>项目视频电话会议系统让您足不出户就能搞定所有项目沟通，会议记录永久留存；所有文档往来、操作记录随时可查，项目管理过程透明可监管。</dd>
            </dl>
          </div>
        </div>
        <div class="box-2">
          <div class="demand-box">
            <div class="title">3分钟描述需求</div>
            <div class="demand-cont">
              <form class="ant-form ant-form-horizontal">
                <div class="ant-row ant-form-item">
                  <div class="">
                    <div class="ant-form-item-control ">
                      <span class="ant-input-wrapper">
                        <input type="text" id="requirement-outline" value="" data-__meta="[object Object]" name="requirement-outline" placeholder="一句话描述自己的需求。" class="ant-input ant-input-lg">
                      </span>
                      <p class="requirement-outline-count-box">
                        <span class="requirement-outline-count">0</span>/20
                      </p>
                    </div>
                  </div>
                </div>
                <div class="ant-row ant-form-item">
                  <div class="ant-setlist">
                    <select style="width:100%;height:50px;border-radius:3px;border: 1px solid #d9d9d9;padding-left:3px;">
                      <option>50万</option>
                      <option>100万</option>
                      <option>150万</option>
                      <option>200万</option>
                    </select>
                  </div>
                </div>
                <div class="ant-row ant-form-item item-time">
                  <div class="">
                    <div class="ant-form-item-control "><b>项目预计开启时间</b></div>
                  </div>
                </div>
                <div class="ant-row ant-form-item">
                  <div class="stepCont stepCont1">
                    <div class='ystep-container ystep-lg ystep-blue'></div>
                  </div>
                </div>
                <div class="ant-row ant-form-item" style="margin-top: 60px; text-align: center;display: block;">
                  <div class="">
                    <div class="ant-form-item-control ">
                      <button id="evaluate" type="submit" class="ant-btn ant-btn-ghost ant-btn-lg submit">
                        <span>立即评估</span></button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="box-3"><img src="../assets/images/bg-2.jpg">
          <div class="title">人体医学生物特征认知诊断系统定制是如何一步步实现的？</div>
          <div class="item-box item-1"><span class="numxx">01</span><i class="icon icon-circle"></i><span>需求预评估</span>
            <div class="item-info">
              <!-- react-text: 120 -->3分钟提交需求，专业顾问与您在线一对一沟通并出具需求预评估报告
              <!-- /react-text --><i class="arrow"></i></div>
          </div>
          <div class="item-box item-2"><span class="numxx">02</span><i class="icon icon-circle"></i><span>产品原型设计</span>
            <div class="item-info">
              <!-- react-text: 127 -->资深产品经理为您的需求进行严密的逻辑梳理，绘制可视化线框图原型
              <!-- /react-text --><i class="arrow"></i></div>
          </div>
          <div class="item-box item-3"><span class="numxx">03</span><i class="icon icon-circle"></i><span>UI设计</span>
            <div class="item-info">
              <!-- react-text: 134 -->UI设计团队紧随当今流行设计趋势，为您的APP打造出色视觉体验
              <!-- /react-text --><i class="arrow"></i></div>
          </div>
          <div class="item-box item-4"><span class="numxx">04</span><i class="icon icon-circle"></i><span>PC和移动端开发</span>
            <div class="item-info">
              <!-- react-text: 141 -->工程师基于APICloud开发平台进行APP端开发，效率更高，性能更稳定
              <!-- /react-text --><i class="arrow"></i></div>
          </div>
          <div class="item-box item-5"><span class="numxx">05</span><i class="icon icon-circle"></i><span>服务器端开发</span>
            <div class="item-info">
              <!-- react-text: 148 -->APICloud服务端开发更全面，涵盖云修复、版本更新、数据统计、推送等强大功能
              <!-- /react-text --><i class="arrow"></i></div>
          </div>
          <div class="item-box item-6"><span class="numxx">06</span><i class="icon icon-circle"></i><span>接口联调</span>
            <div class="item-info">
              <!-- react-text: 155 -->一套代码生成iOS和Android两个APP，真正让接口联调事半功倍
              <!-- /react-text --><i class="arrow"></i></div>
          </div>
          <div class="item-box item-7"><span class="numxx">07</span><i class="icon icon-circle"></i><span>测试及验收</span>
            <div class="item-info">
              <!-- react-text: 162 -->引擎自动适配+海量稳定模块让QA更专注于业务测试，完整递交15项标准化交付产物
              <!-- /react-text --><i class="arrow"></i></div>
          </div>
        </div>
        <div class="box-4">
          <ul>
            <li><span class="icon-box"><i class="icon icon-evaluate"></i></span><span class="name">在线需求预评估</span>
            </li>
            <li><span class="icon-box"><i class="icon icon-conference"></i></span><span class="name">项目全程监理跟进</span>
            </li>
            <li><span class="icon-box"><i class="icon icon-supervise"></i></span><span class="name">标准化验收交付</span>
            </li>
            <li><span class="icon-box"><i class="icon icon-delivery"></i></span><span class="name">更新迭代方便灵活</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <app-footer />
  </div>
</template>
<script>
import header from '@/components/header'
import footer from '@/components/footer'
import { request } from '@/network/request'
import Cookies from 'js-cookie'
import { profile } from '@/api/user';

export default {
  data() {
    return {
      msg: []

    }
  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
  methods: {
    tiao(n, i) {
      let _this = this;
      Cookies.set('typein', 1);
      profile().then(response => {
        if (response.data.code == 200) {
          sessionStorage.setItem('topic', n);
          sessionStorage.setItem('topicname', i);
          localStorage.setItem('baogaoid', 'null');
          _this.$router.push('/topic');

        } else {
          _this.$router.push('/login');
        }
      })

    },
    returnGo() {
      this.$router.go(0);
    },
    Scroll() {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 400) {
        //$('.header-1').fadeIn("slow");
        $(".pageScroll").addClass("pageshow");
      } else if (scrollTop < 400) {
        $(".pageScroll").removeClass("pageshow");
      }
    },
  },
  mounted() {


    let _this = this;
    request({
      url: '/intelligentDetection/device/intelligentDetection',
      method: 'get',
      params: {}
    }).then(res => {
      if (res.data.code == 200) {
        _this.msg = res.data.data;

      } else {

      }

    });

    window.onresize = () => {
      return (() => {
        var step1 = new SetStep({
          content: '.stepCont1',
          showBtn: false,
        });
      })()
    };
    var step1 = new SetStep({
      content: '.stepCont1',
      showBtn: false,
    });
  },
}

</script>
<style>
@import "../assets/css/product.css";
@import "../assets/css/ystep.css";
@import "../assets/css/appcont.css";
@import "../assets/css/all.css";
@import "../assets/css/pagestyle.css";

.ant-setlist select {
  display: block !important;
  margin-top: 24px;
}

.Mselect {
  display: none !important;
}

#huan10_22 {
  background: url(../assets/img/banner_img1.jpg) center no-repeat;
}

.Fpictxt {
  width: 1054px;
  height: 160px;
  margin: 0 auto;
  background: url(../assets/images/features_Picturetext.png) no-repeat center bottom;
  margin-top: 230px;
}

.zhongjiantu3_25 {
  width: 100%;
  background-color: #fff;

}

.zhongjiantu3_25 .continto {
  width: 1140px;
  margin: 0 auto;
  padding-bottom: 30px;
}

.weiqunabox3_25 .weiquna3_25:nth-child(3n) {
  margin-right: 0;
}

.weiquna3_25 {
  width: 360px;
  height: 302px;
  background: #FFFFFF;
  border-radius: 5px;
  float: left;
  padding: 30px 20px;
  box-sizing: border-box;
  margin-right: 28px;
  margin-top: 60px;
  border: 1px solid #E6E6E6;
}

.weiquna3_25:hover {
  border: 1px solid #fff;
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, .08);
}

.weiquna3_25 .img {
  width: 64px;
  height: 64px;
  float: left;
  margin: 0 128px;
  margin-bottom: 30px;
}

.weiquna3_25 .titlewei {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}

.weiquna3_25 .titleweips {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 20px;
  margin-top: 12px;
  margin-bottom: 20px;
}

.weiquna3_25 .btnuni:hover {
  border: 1px solid #14C86C;
  background: #14C86C;
  color: #FFFFFF;
}

.weiquna3_25 .btnuni {
  width: 200px;
  height: 50px;
  line-height: 50px;
  float: left;
  text-align: center;
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000;
  margin-left: 60px;
  background: #FFFFFF;
  border: 1px solid #E6E6E6;
  cursor: pointer;
}

.zhongjiantu3_25 .titlein {
  width: 100%;
  text-align: center;
  float: left;
  font-size: 40px;
  /* font-family: PingFang SC;
  font-weight:bold;*/
  color: #000000;
  line-height: 42px;
  margin: 100px 0;

}

.zhongjiantu3_25 .titleinps {
  width: 100%;
  float: left;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}

.zhongjiantu11_24 {
  width: 100%;
  height: 400px;
  background: #2ca46d;
  /* background: url(../assets/images/zhongjiantu11_24.png) no-repeat center
    bottom; */
}

.zhongjiantu11_24 .continto {
  width: 900px;
  margin: 0 auto;
}

.zhongjiantu11_24 .leftcont {
  width: 500px;
  float: left;
}

.zhongjiantu11_24 .imgin {
  width: 400px;
  height: 400px;
  float: left;
}

.zhongjiantu11_24 .title {
  text-align: left;
  color: #fff;
  font-size: 26px;
  padding: 100px 0;
  line-height: 50px;
}

.btntitle11_24 {
  display: inline-block;
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background-color: #fff;
  font-size: 14px;
  color: #2fb673;
  border-radius: 3px;
}

</style>



// WEBPACK FOOTER //
// src/components/features.vue